import { Locale } from "@/i18n-config";
import { defineLocaleRecord } from "@/i18n-config";

export type WishlistCopy = {
  title: string;
  added: string;
  removed: string;
  unavailable: string;
  emptyTitle: string;
  browseCta: string;
  loginToSave: string;
  addAria: string;
  removeAria: string;
};

const copyByLocale = defineLocaleRecord<WishlistCopy>({
  en: {
    title: "Wishlist",
    added: "Added to wishlist",
    removed: "Removed from wishlist",
    unavailable: "Wishlist is unavailable right now.",
    emptyTitle: "You don't have saved courses yet.",
    browseCta: "Browse courses",
    loginToSave: "Log in to save courses",
    addAria: "Add to wishlist",
    removeAria: "Remove from wishlist",
  },
  fr: {
    title: "Liste d'envies",
    added: "Ajoute a la liste d'envies",
    removed: "Retire de la liste d'envies",
    unavailable: "La liste d'envies est indisponible pour le moment.",
    emptyTitle: "Vous n'avez pas encore de cours enregistres.",
    browseCta: "Parcourir les cours",
    loginToSave: "Connectez-vous pour enregistrer des cours",
    addAria: "Ajouter a la liste d'envies",
    removeAria: "Retirer de la liste d'envies",
  },
  ru: {
    title: "Избранное",
    added: "Добавлено в избранное",
    removed: "Удалено из избранного",
    unavailable: "Список избранного сейчас недоступен.",
    emptyTitle: "У вас пока нет сохраненных курсов.",
    browseCta: "Смотреть курсы",
    loginToSave: "Войдите, чтобы сохранять курсы",
    addAria: "Добавить в избранное",
    removeAria: "Удалить из избранного",
  },
  uk: {
    title: "Обране",
    added: "Додано в обране",
    removed: "Видалено з обраного",
    unavailable: "Список обраного зараз недоступний.",
    emptyTitle: "У вас ще немає збережених курсів.",
    browseCta: "Переглянути курси",
    loginToSave: "Увiйдiть, щоб зберiгати курси",
    addAria: "Додати в обране",
    removeAria: "Видалити з обраного",
  },
  de: {
    title: "Merkliste",
    added: "Zur Merkliste hinzugefuegt",
    removed: "Aus der Merkliste entfernt",
    unavailable: "Die Merkliste ist momentan nicht verfuegbar.",
    emptyTitle: "Du hast noch keine gespeicherten Kurse.",
    browseCta: "Kurse ansehen",
    loginToSave: "Melde dich an, um Kurse zu speichern",
    addAria: "Zur Merkliste hinzufuegen",
    removeAria: "Aus der Merkliste entfernen",
  },
  es: {
    title: "Lista de deseos",
    added: "Anadido a la lista de deseos",
    removed: "Eliminado de la lista de deseos",
    unavailable: "La lista de deseos no esta disponible ahora mismo.",
    emptyTitle: "Aun no tienes cursos guardados.",
    browseCta: "Ver cursos",
    loginToSave: "Inicia sesion para guardar cursos",
    addAria: "Anadir a la lista de deseos",
    removeAria: "Quitar de la lista de deseos",
  },
  it: {
    title: "Lista dei desideri",
    added: "Aggiunto alla lista dei desideri",
    removed: "Rimosso dalla lista dei desideri",
    unavailable: "La lista dei desideri non e disponibile al momento.",
    emptyTitle: "Non hai ancora corsi salvati.",
    browseCta: "Esplora corsi",
    loginToSave: "Accedi per salvare i corsi",
    addAria: "Aggiungi alla lista dei desideri",
    removeAria: "Rimuovi dalla lista dei desideri",
  },
  pt: {
    title: "Lista de desejos",
    added: "Adicionado a lista de desejos",
    removed: "Removido da lista de desejos",
    unavailable: "A lista de desejos nao esta disponivel no momento.",
    emptyTitle: "Voce ainda nao tem cursos salvos.",
    browseCta: "Explorar cursos",
    loginToSave: "Faca login para salvar cursos",
    addAria: "Adicionar a lista de desejos",
    removeAria: "Remover da lista de desejos",
  },
});

export function getWishlistCopy(locale: Locale): WishlistCopy {
  return copyByLocale[locale] ?? copyByLocale.en;
}
